import { useFpB2bProductsInfo } from '@cart-services/hooks/fp-b2b/use-fp-b2b-products-info'
import { type CartItem } from '@cart-services/types'
import { Divider } from '@pets-ui/Divider/Divider'
import { Paper } from '@pets-ui/Paper/Paper'
import { Text, type TextProps } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { scrollToCartListItem } from '../../utils/scrollToListItem'
import { useCart } from '../CartProvider/CartProvider'
import { DrawerHeader } from '../DrawerHeader/DrawerHeader'
import { FooterReminderListItem } from './FooterReminderListItem'

const styles = stylex.create({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    padding: '12px 0',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  maxHeight: (maxHeight: number) => ({
    maxHeight,
  }),
  list: {
    gap: 2,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 12,
  },
})

export interface FooterReminderContentProps {
  titleAlign?: TextProps['align']
  maxHeight?: number
  shortageProducts?: CartItem[]
}

export const FooterReminderContent = (props: FooterReminderContentProps) => {
  const { titleAlign, maxHeight = 110, shortageProducts } = props
  const { projectCode, countryCode, campaignCodeFromUrl, campaignId, platform } = useCart()
  const { productMap } = useFpB2bProductsInfo({ projectCode, countryCode, campaignCode: campaignCodeFromUrl, campaignId, platform })

  const handleClick = (itemIndex?: number) => () => {
    if (itemIndex) {
      scrollToCartListItem(itemIndex)
    }
  }

  return (
    <Paper elevation={0} borderRadius={0} rootStyle={styles.root}>
      <DrawerHeader align={titleAlign} pt={0}>缺貨</DrawerHeader>
      <Divider />
      <div {...stylex.props(styles.content, styles.maxHeight(maxHeight))}>
        <Text variant="caption" color={colors.grey700}>部分商品庫存不足，請聯繫經銷商或客服</Text>
        <div {...stylex.props(styles.list)}>
          {
            shortageProducts?.map(item => (
              <FooterReminderListItem
                title={item.sku}
                key={item.cartItemId}
                stock={Number(productMap?.[item.variation_id]?.stock)}
                onClick={handleClick(item.butler.itemIndex)}
              />
            ))
          }
        </div>
      </div>
    </Paper>
  )
}
